import React from "react";
import { FaDownload, FaUpload } from "react-icons/fa";

const ImportExport = ({ onImport, onExport, loading }) => {
    const buttonBase =
        "flex items-center rounded-md px-4 py-2 font-medium text-sm w-full transition";
    const buttonExport =
        "bg-green-50 border border-green-400 text-green-700 hover:bg-green-100 hover:border-green-600";
    const buttonImport =
        "bg-blue-50 border border-blue-400 text-blue-700 hover:bg-blue-100 hover:border-blue-600";

    return (
        <div className="flex gap-2 w-full">
            <button
                className={`${buttonBase} ${buttonImport} relative`}
                onClick={onImport}
                disabled={loading}
                type="button"
                title="Importer un fichier de codes comptables"
            >
                <FaUpload className="mr-2" />
                Importer
            </button>
            <button
                className={`${buttonBase} ${buttonExport} relative`}
                onClick={onExport}
                disabled={loading}
                type="button"
                title="Exporter les codes comptables actuels"
            >
                {loading ? (
                    <span className="mr-2 animate-spin h-4 w-4 border-2 border-green-600 border-t-transparent rounded-full"></span>
                ) : (
                    <FaDownload className="mr-2" />
                )}
                Exporter
            </button>
        </div>
    );
};

export default ImportExport;